import React from 'react';
import { FormattedMessage } from 'react-intl';

function FurtherAction ({ data, onCTAHandler }) {

    const { btnText, processedParagraphText } = data;

    return (data &&
        <div className="gi-panel gi-member_portal_panel" id="auto-further-action">
            <div className="grid-row">
                <h4 className="" id="further-action-header">
                    <FormattedMessage id='indportal.dashboard.furtherAction.paragraphHeader' />
                </h4>
            </div>
            <div className="grid-row" id="further-action-txt">
                { processedParagraphText }
            </div>
            {btnText &&
            <div className="grid-row">
                <div className="grid-col-12">
                    <div className="buttons-group text-right">
                        <button
                            type="button"
                            dataAutomationId={btnText}
                            id="further-action-btn"
                            className="usa-button gi-button gi-button__primary"
                            onClick={ () => onCTAHandler({ data }) }
                        >
                            <FormattedMessage id={btnText} />
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    );
}

export default FurtherAction;